import React, { useEffect, useState } from 'react';
import { learnerApi } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import StatCard from '../../components/common/StatCard';
import Spinner  from '../../components/common/Spinner';
import { FaCalendarCheck, FaChartBar, FaBullhorn, FaCalendarAlt, FaBook } from 'react-icons/fa';

export default function LearnerDashboard() {
  const { user, school } = useAuth();
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    learnerApi.getDashboard()
      .then(r => setData(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  const att    = data?.attendance;
  const attPct = att?.total > 0 ? Math.round((att.present / att.total) * 100) : null;

  return (
    <div>
      <div className="page-header">
        <h2>Welcome, {user?.first_name}! 👋</h2>
        <p>{school?.name} — {data?.profile?.grade_number ? `Grade ${data.profile.grade_number}` : ''}</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 16, marginBottom: 28 }}>
        <StatCard label="Attendance"    value={attPct !== null ? `${attPct}%` : '—'} icon={FaCalendarCheck} color={attPct >= 75 ? '#10b981' : '#ef4444'} sub={`${att?.present || 0} / ${att?.total || 0} days`} />
        <StatCard label="Assessments"   value={data?.recent_marks?.length || 0}       icon={FaChartBar}      color="#0d6efd" />
        <StatCard label="Notices"       value={data?.notices?.length || 0}            icon={FaBullhorn}      color="#f59e0b" />
        <StatCard label="Upcoming"      value={data?.events?.length || 0}             icon={FaCalendarAlt}   color="#8b5cf6" sub="events" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Recent marks */}
        <div className="sms-card">
          <h5 style={{ fontWeight: 600, marginBottom: 16 }}>Recent Marks</h5>
          {data?.recent_marks?.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {data.recent_marks.map((m, i) => {
                const pct = m.total_marks > 0 ? Math.round((m.score / m.total_marks) * 100) : null;
                return (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: '#f9fafb', borderRadius: 8 }}>
                    <div>
                      <div style={{ fontWeight: 500, fontSize: '0.88rem' }}>{m.subject_name}</div>
                      <div style={{ color: '#9ca3af', fontSize: '0.75rem' }}>{m.assessment_name} · {m.date}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 700, color: pct >= 75 ? '#10b981' : pct >= 50 ? '#f59e0b' : '#ef4444' }}>{m.score}/{m.total_marks}</div>
                      <div style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{pct}%</div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : <p style={{ color: '#9ca3af' }}>No marks recorded yet</p>}
        </div>

        {/* Notices */}
        <div className="sms-card">
          <h5 style={{ fontWeight: 600, marginBottom: 16 }}>Latest Notices</h5>
          {data?.notices?.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {data.notices.map(n => (
                <div key={n.notice_id} style={{ padding: '10px 12px', background: '#f9fafb', borderRadius: 8, borderLeft: `3px solid ${n.is_pinned ? '#f59e0b' : '#0d6efd'}` }}>
                  {n.is_pinned && <div style={{ fontSize: '0.7rem', color: '#f59e0b', fontWeight: 700, marginBottom: 3 }}>📌 PINNED</div>}
                  <div style={{ fontWeight: 500, fontSize: '0.88rem' }}>{n.title}</div>
                  <div style={{ color: '#9ca3af', fontSize: '0.75rem', marginTop: 3 }}>{new Date(n.created_at).toLocaleDateString()}</div>
                </div>
              ))}
            </div>
          ) : <p style={{ color: '#9ca3af' }}>No notices</p>}
        </div>

        {/* Upcoming events */}
        {data?.events?.length > 0 && (
          <div className="sms-card" style={{ gridColumn: '1/-1' }}>
            <h5 style={{ fontWeight: 600, marginBottom: 16 }}>Upcoming Events</h5>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {data.events.map(e => (
                <div key={e.event_id} style={{ background: '#f0f2f5', borderRadius: 10, padding: '12px 16px', minWidth: 160 }}>
                  <div style={{ fontWeight: 600, fontSize: '0.88rem' }}>{e.title}</div>
                  <div style={{ color: '#6b7280', fontSize: '0.78rem', marginTop: 4 }}>{new Date(e.event_date).toLocaleDateString('en', { day: 'numeric', month: 'short' })}</div>
                  <div style={{ fontSize: '0.72rem', color: '#0d6efd', textTransform: 'capitalize', marginTop: 3 }}>{e.event_type}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
